import { useEffect, useState } from "react";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 300px (well below the hero CTA buttons)
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      className={`md:hidden fixed bottom-5 left-0 right-0 z-40 flex justify-center px-4 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <button
        onClick={handleClick}
        className="flex items-center gap-2.5 bg-forest-600 hover:bg-forest-700 active:bg-forest-800 text-white text-sm font-semibold px-6 py-3.5 rounded-full cursor-pointer whitespace-nowrap w-full max-w-xs justify-center"
        style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.25)" }}
      >
        <i className="ri-calendar-check-line text-base" />
        Book Free Consultation
      </button>
    </div>
  );
}
